import { render, staticRenderFns } from "./WizardPad.vue?vue&type=template&id=200e5d86&scoped=true&"
import script from "./WizardPad.vue?vue&type=script&lang=ts&"
export * from "./WizardPad.vue?vue&type=script&lang=ts&"
import style0 from "./WizardPad.vue?vue&type=style&index=0&id=200e5d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200e5d86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200e5d86')) {
      api.createRecord('200e5d86', component.options)
    } else {
      api.reload('200e5d86', component.options)
    }
    module.hot.accept("./WizardPad.vue?vue&type=template&id=200e5d86&scoped=true&", function () {
      api.rerender('200e5d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/rooms/WizardPad.vue"
export default component.exports